module.exports = __webpack_public_path__ + "static/media/permata.5d835e52.svg";